import React, { useContext, useState, useEffect } from 'react';
import {
  BusFareDepartContext,
  BusFareReturnContext,
  LoyaltyDiscountContext,
  TotalBusFareContext,
  VoucherCodeContext,
  VoucherDiscountContext,
  SelectSeatDepartContext,
  InsuranceAddonContext,
  HealthCareAddOnContext,
  CurrentCurrencyContext,
  CurrencyContext,
  ValueMealAddonContext,
} from '../UserContext';
import {
  getMonetaryUnitText,
  getSelectedAddOnData,
  sessionStorageGetItem,
  sessionStorageSetItem,
} from './Function';

export const BusFareTotal = ({ page }) => {
  // Contexts
  const { BusFareDepart } = useContext(BusFareDepartContext);
  const { BusFareReturn } = useContext(BusFareReturnContext);
  const { insuranceAddOn } = useContext(InsuranceAddonContext);
  const { healthCareAddOn } = useContext(HealthCareAddOnContext);
  const { valueMealAddon } = useContext(ValueMealAddonContext);
  const { TotalBusFare, setTotalBusFare } = useContext(TotalBusFareContext);
  const { TotalLoyalty, setLoyalty } = useContext(LoyaltyDiscountContext);
  const { VoucherDiscount } = useContext(VoucherDiscountContext);
  const { selectedDepartSeat } = useContext(SelectSeatDepartContext);
  const { currentCurrency } = useContext(CurrentCurrencyContext);
  const { exchangeCurrency } = useContext(CurrencyContext);

  // State
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDisplay, setTotalDisplay] = useState(0);

  const monetaryUnit = getMonetaryUnitText(currentCurrency);

  // Utils
  const parseFare = (fareObj, key) => (fareObj ? Number(fareObj[key] || 0) : 0);
  const convertCurrency = (amount, rate) =>
    currentCurrency === 'MYR' ? amount : amount / rate;

  // Load data from sessionStorage
  const departBusFare = JSON.parse(sessionStorageGetItem('departBusFare'));
  const returnBusFare = JSON.parse(sessionStorageGetItem('returnBusFare'));
  const sessionInsurance = JSON.parse(sessionStorageGetItem('insuranceAddOn'));
  const sessionHealthCare = JSON.parse(
    sessionStorageGetItem('healthCareAddOn')
  );
  const sessionValueMeal = JSON.parse(sessionStorageGetItem('valueMealAddOn'));
  const departDataMultiModal = JSON.parse(
    sessionStorageGetItem('departDataMultiModal')
  );
  const storedDepartSeats = JSON.parse(
    sessionStorageGetItem('selectedDepartSeat')
  );
  // }

  // Calculate base bus fare
  const baseFare =
    parseFare(departBusFare, 'fare') + parseFare(returnBusFare, 'fare');

  const displayBaseFare =
    parseFare(departBusFare, currentCurrency === 'MYR' ? 'fare' : 'sgdFare') +
    parseFare(returnBusFare, currentCurrency === 'MYR' ? 'fare' : 'sgdFare');

  // Calculate add-on fares
  const addOnItems = [
    insuranceAddOn?.fee || sessionInsurance?.fee || 0,
    healthCareAddOn?.fee || sessionHealthCare?.fee || 0,
    valueMealAddon?.fee || sessionValueMeal?.fee || 0,
  ];

  const addOnTotal = addOnItems.reduce(
    (sum, item) =>
      sum + convertCurrency(Number(item || 0), exchangeCurrency.addOnCurrency),
    0
  );

  // Calculate selected custom add-ons
  const addOnData = getSelectedAddOnData();
  const customAddOnTotal =
    addOnData?.reduce((sum, item) => {
      const value =
        currentCurrency === 'MYR'
          ? Number(item.totalamtinmyr)
          : Number(item.totalamtinsgd || 0);
      return sum + value;
    }, 0) || 0;

  // Compute private hire fare
  const selectedSeats = selectedDepartSeat?.length
    ? selectedDepartSeat
    : storedDepartSeats || [];

  const privateHireFare =
    departDataMultiModal && selectedSeats.length
      ? selectedSeats.length *
        (currentCurrency === 'MYR'
          ? departDataMultiModal.fare
          : departDataMultiModal.adultPriceInSgd || 0)
      : 0;

  // Loyalty cap
  const loyaltyToApply = Math.min(TotalLoyalty || 0, baseFare + addOnTotal);

  // Calculate final fares
  useEffect(() => {
    const totalBusFare = baseFare + addOnTotal;
    const fullAmount =
      displayBaseFare +
      addOnTotal +
      customAddOnTotal +
      privateHireFare -
      (loyaltyToApply + VoucherDiscount);

    setTotalBusFare(totalBusFare);
    setTotalAmount(fullAmount);
    setTotalDisplay(fullAmount);
    sessionStorageSetItem('busFare', JSON.stringify(totalBusFare));
  }, [
    baseFare,
    addOnTotal,
    customAddOnTotal,
    privateHireFare,
    loyaltyToApply,
    VoucherDiscount,
    currentCurrency,
  ]);

  // Set loyalty from session if on payment/checkout page
  useEffect(() => {
    if (['payment', 'checkout'].includes(page)) {
      const savedFare = JSON.parse(sessionStorageGetItem('busFare')) || 0;
      const savedLoyalty = JSON.parse(sessionStorageGetItem('loyalty')) || 0;
      setTotalBusFare(savedFare);
      setLoyalty(savedLoyalty);
    }
  }, [page]);

  return (
    <div className='bus-fare-total'>
      <table className='mt-4 add-on-table'>
        <tbody>
          <tr>
            <td>
              <h6>Total</h6>
            </td>
            <td>
              <h3 style={{ textAlign: 'right' }}>
                {monetaryUnit} {totalDisplay.toFixed(2)}
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
